<template>
  <div class="viewer">
    <object
      :data="pdf"
      type="application/pdf"
      width="100%"
      height="100%"
    >
      <iframe
        :src="pdf"
        width="100%"
        height="100%"
        style="border: none;"
      >
        This browser does not support PDFs. Please download the PDF to view it: <a :href="pdf">Download PDF</a>
      </iframe>
    </object>
  </div>
</template>
<script>
export default {
  name: 'CM_PdfViewer',
  props: {
    pdf: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
.viewer {
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
